const offerItemsFilters = [];

export default offerItemsFilters;
